import {TextArea} from '@/components/atoms'
import {withJsonFormsControlProps} from '@jsonforms/react'

const TextAreaComponent = props => {
  /**
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle changes in the text area.
   * @property {string} label - Label for the text area.
   * @property {Object} data - Data associated with the text area.
   * @property {string} path - Path to the data.
   * @property {string} error - Error message to display.
   * @property {Object} schema - Schema for the text area.
   * @property {Object} uischema - UI schema for the text area.
   * @property {boolean} required - Indicates if the text area is required.
   * @property {boolean} enabled - Indicates if the text area is enabled.
   * @property {boolean} visible - Indicates if the text area is visible.
   */
  const {handleChange, label, data, path, error, schema, uischema, required, enabled, visible} = props
  return (
    visible && (
      <TextArea
        value={data}
        label={label}
        updateValue={newVal => handleChange(path, newVal)}
        error={error}
        schema={schema}
        uiSchema={uischema}
        required={required}
        disabled={!enabled}
      />
    )
  )
}

const TextAreaControl = withJsonFormsControlProps(TextAreaComponent)
export default TextAreaControl
